import React from 'react';
import classNames from 'classnames';
import styles from './playerRow.module.scss';

export default function PlayerRow(props: {
  name: string;
  avatar?: string;
  rank?: number;
  className?: string;
  online?: boolean;
  isOpen?: boolean;
}) {
  return (
    <div className={classNames(styles.playerRow, props.className)}>
      {props.rank && <span className={styles.rank}>{props.rank}</span>}
      <div className={props.online ? styles.online : styles.offline} />
      {props.avatar && <div className={classNames(styles.avatar, 'avatar-overlay')}>
        <img className='avatar' src={props.avatar} alt={props.name} />
        </div>}
      <span>{props.name}</span>
    </div>
  );
}
